export default __webpack_public_path__ + "static/media/hero-four-shape.735708f1.png";